module.exports = __webpack_public_path__ + "img/文涛.bf84f46d.jpeg";